import { LocalizationContextBuilder } from '@amzn/arb-tools';
import arbManifest from '../../../build/translations/arbManifest';
export const DEFAULT_LOCALE = 'en-US';
export const localizationContextBuilder = new LocalizationContextBuilder().withDefaultLocale(DEFAULT_LOCALE);
const mbmOption = {
    arbManifest,
    defaultLocalizationContext: localizationContextBuilder.withLocale(DEFAULT_LOCALE).build(),
    urlPrefix: '/translations',
};
export default mbmOption;
